import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
export function getInitialSelection() {
    return {
        selectedOptionIndex: 0,
        labelToDisplay: null,
        previousState: {
            labelToDisplay: null,
            selectedOptionIndex: 0
        }
    };
}
function reducer(state, action) {
    switch(action.type){
        case 'selectOption':
            {
                return _object_spread_props(_object_spread({}, state), {
                    selectedOptionIndex: action.value.index
                });
            }
        case 'applyChanges':
            {
                const { previousState: _ } = state, currentState = _object_without_properties(state, [
                    "previousState"
                ]);
                const labelToDisplay = state.selectedOptionIndex !== 0 && action.label || null;
                const newState = _object_spread_props(_object_spread({}, currentState), {
                    labelToDisplay
                });
                return _object_spread_props(_object_spread({}, newState), {
                    previousState: _object_spread({}, newState)
                });
            }
        case 'revert':
            {
                const { previousState } = state;
                return _object_spread_props(_object_spread({}, previousState), {
                    previousState
                });
            }
        default:
            throw new Error('unknown filters action');
    }
}
export function createReducer() {
    return reducer;
}
